// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__Z-VQ8","navbar":"App_navbar__1mR2w","content":"App_content__3Yxrg","main":"App_main__9tVZ8","footer":"App_footer__evkm_"};